const selfUploadModal = {
  success: {
    title: "Upload Complete",
    subtitle: "Your file has been de-identified and is ready to download",
    processedNote: "Processed with de-identification",
    rowsCount: "{{rowCount}} rows",
    readyNote: "Ready to download or share",
    downloading: "Downloading...",
    downloadWorkbook: "Download De-identified Workbook",
    downloadFile: "Download De-identified File",
    csvButtonTitle:
      "Flattened first sheet, supports selecting a column subset",
    asCsv: "as CSV",
    findFileInCatalog: "You can also find this file in your",
    dataCatalogLink: "data catalog",
  },
  header: {
    title: "Upload My Data",
    subtitle:
      "Your file will be de-identified and stored securely. You choose who can access it.",
  },
};

export default selfUploadModal;
